import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";


class Page extends React.Component {
    
  
    componentDidMount = async () => {
        this.getPage();
    };


    componentDidUpdate = async(prevProps, nextProps)=>{
        if(prevProps.params.id != this.props.params.id){
            this.getPage();
        }
    }

    getPage = async()=>{
        window.scroll(0, 0);
        var id = await this.props.params.id;
        if(id){
            var response = await Api.GetRequest({}, 'page/'+id);
            if(response.status == 200){
                this.setState({'page' : response.page});
            }
            else{
                toast.error("Something went wrong. Please try again later.");
            }
        }
        else{
            this.props.navigate(-1)
        }
       
    }
  

    constructor(props) {
        super(props);
        this.state = {
            'page' : {
                'description' : "",
                'description_height' : ""
            }
        };
        this.description_ref = React.createRef()
    }

    
    setDescriptionHeight = async()=>{
        var height = this.description_ref.current.contentWindow.document.body.scrollHeight + 50;
        this.setState({'description_height' : height + "px"});
    }

   
    render(){

        return(
            <>
               
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src={process.env.REACT_APP_SERVER + this.state.page.image}/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000', "textTransform" : "uppercase"}}>{this.state.page.title}</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="news_details_main" class="">
                    <div class="container">
                        <div class="row" id="counter">
                            <div class="col-lg-12">
                                <div class="details_wrapper_area">
                                   
                                    <div class="details_text_wrapper text-start p-0">
                                        {/* <h2 className="text-center mb-5">{this.state.page.title}</h2> */}
                                        
                                        <iframe  onLoad={()=>{this.setDescriptionHeight()}} scrolling="no" frameBorder="0" height={this.state.description_height} srcDoc={this.state.page.description} ref={this.description_ref}  style={{'width':'100%'}}/>
                                        
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


export default withRouter(Page)